// assets/variant-squares.js
(function () {
  const DEBUG = false;

  function log(...args) { if (DEBUG) console.log("[variant-squares]", ...args); }

  function getImages(card) {
    if (!card) return {};
    const primary = card.querySelector(".product-card__image--primary");
    const secondary = card.querySelector(".product-card__image--secondary");
    return { primary, secondary };
  }

  function saveOriginals(img) {
    if (!img) return;
    if (!img.dataset.originalSrc)     img.dataset.originalSrc     = img.currentSrc || img.src || "";
    if (!img.dataset.originalSrcset)  img.dataset.originalSrcset  = img.srcset || "";
  }

  function swap(img, url) {
    if (!img || !url) return;
    saveOriginals(img);
    // Clear srcset so the browser doesn't ignore src
    img.srcset = "";
    img.src = url;
  }

  function revert(img) {
    if (!img || !img.dataset.originalSrc) return;
    img.src = img.dataset.originalSrc;
    img.srcset = img.dataset.originalSrcset || "";
  }

  // If your theme uses a "secondary" hover image overlay, we prefer swapping that,
  // otherwise swap the primary.
  function pickTargetImage(card) {
    const { primary, secondary } = getImages(card);
    return secondary || primary || null;
  }

  function wire(dotsWrap) {
    if (!dotsWrap || dotsWrap.__wired) return;
    dotsWrap.__wired = true;

    const card = dotsWrap.closest(".product-card");
    const targetImg = pickTargetImage(card);
    if (!targetImg) {
      log("No target image found in card", card);
      return;
    }

    // Hover/focus swap
    dotsWrap.addEventListener("pointerenter", (e) => {
      const dot = e.target.closest(".pc-variant-dot");
      if (!dot || !dotsWrap.contains(dot)) return;
      const url = dot.getAttribute("data-variant-image");
      log("enter dot -> swap", { url });
      if (url) swap(targetImg, url);
    });

    // Moving between dots should keep the preview; leaving the wrapper reverts
    dotsWrap.addEventListener("pointerleave", () => {
      log("leave dots -> revert");
      revert(targetImg);
    });

    // Keyboard support
    dotsWrap.addEventListener("focusin", (e) => {
      const dot = e.target.closest(".pc-variant-dot");
      if (!dot) return;
      const url = dot.getAttribute("data-variant-image");
      log("focusin dot -> swap", { url });
      if (url) swap(targetImg, url);
    });
    dotsWrap.addEventListener("focusout", () => {
      // Revert if focus leaves the cluster
      const active = document.activeElement;
      if (active && dotsWrap.contains(active)) return;
      log("focusout dots -> revert");
      revert(targetImg);
    });
  }

  function init(root = document) {
    root.querySelectorAll(".pc-variant-dots").forEach(wire);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  // Handle products added after filters/pagination
  const mo = new MutationObserver((ms) => {
    ms.forEach((m) => {
      m.addedNodes.forEach((n) => {
        if (!(n instanceof Element)) return;
        if (n.matches && n.matches(".pc-variant-dots")) wire(n);
        n.querySelectorAll && n.querySelectorAll(".pc-variant-dots").forEach(wire);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
